export const isAssetFile = (path: string): boolean => {
  const assetExtensions = ['.png', '.jpg', '.jpeg', '.ico', '.webp', '.bmp', '.tiff'];
  return assetExtensions.some((ext) => path.toLowerCase().endsWith(ext));
};
export const isBinaryFile = (path: string): boolean => {
  const binaryExtensions = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.ico',
    '.webp',
    '.bmp',
    '.tiff',
    '.mp4',
    '.mp3',
    '.mov',
    '.avi',
    '.wmv',
    '.flv',
    '.webm',
    '.pdf',
    '.zip',
    '.tar',
    '.gz',
    '.rar',
    '.7z',
    '.iso',
    '.dmg',
    '.exe',
    '.dll',
    '.lib',
    '.so',
  ];
  return binaryExtensions.some((ext) => path.toLowerCase().endsWith(ext));
};

export const isFontFile = (path: string): boolean => {
  const fontExtensions = ['.ttf', '.otf', '.woff', '.woff2', '.eot'];
  return fontExtensions.some((ext) => path.toLowerCase().endsWith(ext));
};

export const isTestFile = (path: string): boolean => {
  return (
    path.includes('.test.') || path.includes('.spec.') || path.includes('__tests__/') || path.includes('__mocks__/')
  );
};

export const CHECK_IGNORE_FILE = (path: string): boolean => {
  const lowerPath = path.toLowerCase();

  // Don't ignore contributor, .env* and readme files, because they are important for the AI to understand the project setup
  if (
    lowerPath.includes('contributor.md') ||
    lowerPath.includes('contributing.md') ||
    lowerPath.includes('contributors.md') ||
    lowerPath.includes('readme.md') ||
    lowerPath.startsWith('.env')
  ) {
    return false;
  }

  // 1. Files that should ALWAYS be ignored (highest precedence)
  if (
    path.startsWith('.') || // Dotfiles - .gitignore, etc.
    lowerPath.includes('package-lock.json') || // Lock files
    lowerPath.includes('yarn.lock') ||
    lowerPath.includes('pnpm-lock.yaml') ||
    lowerPath.includes('bun.lockb') ||
    lowerPath.includes('LICENSE') ||
    isTestFile(path) // Test files (already handles various patterns)
  ) {
    return true; // IGNORE these
  }

  // Specific non-asset media types that were previously ignored and likely still should be
  const nonEssentialMediaExtensions = ['.mp4', '.mp3', '.mov', '.avi', '.wmv', '.flv', '.webm', '.gif'];

  if (nonEssentialMediaExtensions.some((ext) => lowerPath.endsWith(ext))) {
    return true; // IGNORE these
  }

  // 2. Files that should NOT be ignored (these are required for frontend builds)
  const requiredExtensions = [
    // JavaScript & TypeScript & Variants
    '.js',
    '.jsx',
    '.ts',
    '.tsx',
    '.mjs',
    '.cjs',
    '.html',
    '.htm',
    '.vue',
    '.svelte',
    '.astro',
    '.pug',
    '.hbs',
    '.ejs',
    '.css',
    '.scss',
    '.sass',
    '.less',
    '.styl',
    '.pcss',
    '.postcss',
    '.json',
  ];

  if (requiredExtensions.some((ext) => lowerPath.endsWith(ext))) {
    return false; // DO NOT IGNORE
  }

  if (isAssetFile(path) || isFontFile(path)) {
    return true;
  }

  return true; // IGNORE all others
};

export const IGNORE_FILE_CONTENT_FOR_WORKBENCH = (path: string): boolean => {
  const lowerPath = path.toLowerCase();

  console.log('>>>[IGNORE_FILE_CONTENT_FOR_WORKBENCH] path: ', path);

  // Specific non-asset media types that were previously ignored and likely still should be
  if (lowerPath.includes('__pycache__') || lowerPath.includes('build') || lowerPath.includes('dist')) {
    return true; // IGNORE these
  }

  const nonEssentialMediaExtensions = ['.mp4', '.mp3', '.mov', '.avi', '.wmv', '.flv', '.webm', '.gif'];

  if (nonEssentialMediaExtensions.some((ext) => lowerPath.endsWith(ext))) {
    return true; // IGNORE these
  }

  return false; // IGNORE all others
};

export const UNNECESSARY_FILE_FOR_AI_PROCESSING = (path: string): boolean => {
  const lowerPath = path.toLowerCase();

  if (
    lowerPath.includes('__pycache__') ||
    lowerPath.includes('build') ||
    lowerPath.includes('dist') ||
    lowerPath.includes('node_modules') ||
    lowerPath.includes('package-lock.json') ||
    lowerPath.includes('yarn.lock') ||
    lowerPath.includes('pnpm-lock.yaml') ||
    lowerPath.includes('bun.lockb') ||
    lowerPath.includes('LICENSE')
  ) {
    return true; // IGNORE these
  }

  return false;
};
